import React, { useState } from 'react';
import { Box, TextInput, Button, Stack } from '@mantine/core';

export default function IdCountryPage() {
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`/server/zoho_auth/generate?merchant_id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }       
      });
      if (!response.ok) {
        throw new Error('Failed to authenticate');
      }
      const result = await response.json();
      alert(`Success: ${JSON.stringify(result)}`);
    } catch (error: any) {
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maw={400} mx="auto" py="xl">
      <h1>Authenticate your Customer Portal</h1>
      <form onSubmit={handleSubmit}>
        <Stack>
          <TextInput
            label="merchant_id"
            placeholder="Enter your Merchant ID"
            value={id}
            onChange={e => setId(e.currentTarget.value)}
            required
          />          
          <Button type="submit" loading={loading} style={{ backgroundColor: "#00ddb3", color: "white" }}>Submit</Button>
        </Stack>
      </form>
    </Box>
  );
}